"use client";
import { useState } from 'react';
import Container from '../../../common/general/container/Container';
import LinkUrl from '../../../common/general/link/LinkUrl';
import Chevron from '../../../common/svg/Chevron';
import style from './footerBottom.module.scss';
import MenuItemDto from '@/projectRoot/api-client/interfaces/models/content/menu/MenuItem.dto';
import { useGlobals } from '@/projectRoot/src/contexts/GlobalsContext';

interface Props {
    menu_items: MenuItemDto[];
}

const FooterBottom = ({menu_items}: Props) => {
    const [showSubmenu, setShowSubmenu] = useState<string>('');
    const {isMobileView} = useGlobals();
    const menuItems: MenuItemDto[] = [
        {
            title: 'New',
            call_to_action_url: '/',
            order: 0,
            id: '#0001',
            menu: 'footer_menu',
            children: [
                {
                    title: 'New 1',
                    call_to_action_url: '/',
                    call_to_action_text: '',
                    order: 0,
                    id: '#001',
                    menu: 'footer_menu'
                },
                {
                    title: 'New 2',
                    call_to_action_url: '/',
                    order: 1,
                    call_to_action_text: '',
                    id: '#002',
                    menu: 'footer_menu'
                },
                {
                    title: 'New 3',
                    call_to_action_url: '/',
                    call_to_action_text: '',
                    order: 2,
                    id: '#003',
                    menu: 'footer_menu'
                },
                {
                    title: 'New 4',
                    call_to_action_url: '/',
                    call_to_action_text: '',
                    order: 3,
                    id: '#004',
                    menu: 'footer_menu'
                },
                {
                    title: 'New 5',
                    call_to_action_url: '/',
                    call_to_action_text: '',
                    order: 4,
                    id: '#005',
                    menu: 'footer_menu'
                },
                {
                    title: 'New 6',
                    call_to_action_url: '/',
                    call_to_action_text: '',
                    order: 5,
                    id: '#006',
                    menu: 'footer_menu'
                },
                {
                    title: 'New 7',
                    call_to_action_url: '/',
                    call_to_action_text: '',
                    order: 6,
                    id: '#007',
                    menu: 'footer_menu'
                },
            ],
        },
        {
            title: 'FIR',
            call_to_action_url: '/',
            id: '#0002',
            order: 1,
            menu: 'footer_menu',
            children: [
                {
                    title: 'Fir 1',
                    call_to_action_url: '/',
                    call_to_action_text: '',
                    id: '#001',
                    order: 0,
                    menu: 'footer_menu'
                },
                {
                    title: 'Fir 2',
                    call_to_action_url: '/',
                    call_to_action_text: '',
                    id: '#002',
                    order: 1,
                    menu: 'footer_menu'
                },
                {
                    title: 'Fir 3',
                    call_to_action_url: '/',
                    call_to_action_text: '',
                    id: '#003',
                    order: 2,
                    menu: 'footer_menu'
                },
                {
                    title: 'Fir 4',
                    call_to_action_url: '/',
                    id: '#004',
                    order: 3,
                    menu: 'footer_menu'
                },
                {
                    title: 'Fir 5',
                    call_to_action_url: '/',
                    id: '#005',
                    order: 4,
                    menu: 'footer_menu'
                },
                {
                    title: 'Fir 6',
                    call_to_action_url: '/',
                    id: '#006',
                    order: 5,
                    menu: 'footer_menu'
                },
                {
                    title: 'Fir 7',
                    call_to_action_url: '/',
                    id: '#007',
                    order: 6,
                    menu: 'footer_menu'
                },
            ]
        },
        {
            title: 'Beachwear',
            call_to_action_url: '/',
            id: '#0003',
            order: 2,
            menu: 'footer_menu',
            children: [
                {
                    title: 'Beachwear 1',
                    call_to_action_url: '/',
                    id: '#008',
                    order: 0,
                    menu: 'footer_menu'
                },
                {
                    title: 'Beachwear 2',
                    call_to_action_url: '/',
                    id: '#009',
                    order: 1,
                    menu: 'footer_menu'
                },
                {
                    title: 'Beachwear 3',
                    call_to_action_url: '/',
                    id: '#010',
                    order: 2,
                    menu: 'footer_menu'
                },
                {
                    title: 'Beachwear 4',
                    call_to_action_url: '/',
                    id: '#011',
                    order: 3,
                    menu: 'footer_menu'
                },
                {
                    title: 'Beachwear 5',
                    call_to_action_url: '/',
                    id: '#012',
                    order: 4,
                    menu: 'footer_menu'
                },
                {
                    title: 'Beachwear 6',
                    call_to_action_url: '/',
                    id: '#013',
                    order: 5,
                    menu: 'footer_menu'
                },
                {
                    title: 'Beachwear 7',
                    call_to_action_url: '/',
                    id: '#014',
                    order: 6,
                    menu: 'footer_menu'
                },
            ]
        },
        {
            title: 'Accessories',
            call_to_action_url: '/',
            id: '#0003',
            order: 3,
            menu: 'footer_menu' 
        },
        {
            title: 'Tights',
            call_to_action_url: '/',
            order: 4,
            id: '#0004',
            menu: 'footer_menu'
        },
        {
            title: 'Sleepwear',
            call_to_action_url: '/',
            order: 5,
            id: '#0005',
            menu: 'footer_menu',
            children: [
                {
                    title: 'Sleepwear 1',
                    call_to_action_url: '/',
                    order: 0,
                    id: '#001',
                    menu: 'footer_menu'
                },
                {
                    title: 'Sleepwear 2',
                    call_to_action_url: '/',
                    order: 1,
                    id: '#002',
                    menu: 'footer_menu'
                },
                {
                    title: 'Sleepwear 3',
                    call_to_action_url: '/',
                    order: 2,
                    id: '#003',
                    menu: 'footer_menu'
                },
                {
                    title: 'Sleepwear 4',
                    call_to_action_url: '/',
                    order: 3,
                    id: '#004',
                    menu: 'footer_menu'
                },
                {
                    title: 'Sleepwear 5',
                    call_to_action_url: '/',
                    order: 4,
                    id: '#005',
                    menu: 'footer_menu'
                },
                {
                    title: 'Sleepwear 6',
                    call_to_action_url: '/',
                    order: 5,
                    id: '#006',
                    menu: 'footer_menu'
                },
                {
                    title: 'Sleepwear 7',
                    call_to_action_url: '/',
                    order: 6,
                    id: '007',
                    menu: 'footer_menu'
                },
            ]
        },
        {
            title: 'Underwear',
            call_to_action_url: '/',
            order: 6,
            id: '#0008',
            menu: 'footer_menu'
        },
    ];
    const onClickShowSubmenu = (id: string) => {
        setShowSubmenu(showSubmenu == id ? '' : id);
    }
  return (
    <section className={style.footerBottom}>
        <nav className={style.footerMenuWrapper}>
            <Container fluid={isMobileView}>
                <ul className={style.footerMenu}>
                    {
                        menu_items.map((item, index) => {
                            return (
                                <li className={style.menuItem} key={item.title + item.id + index}>
                                    <LinkUrl url={item.call_to_action_url} text={item.title} classes={[style.menuLink]} />
                                    {
                                        item.children && item.children.length > 0
                                        ?
                                        <>
                                            <span className={`${style.chevron} ${item.title + index == showSubmenu ? style.rotated : ''}`} onClick={() => onClickShowSubmenu(item.title + index)}>
                                                <Chevron width={13} height={7} />
                                            </span>
                                            <div className={`${style.submenu} ${item.title + index == showSubmenu ? style.visible : ''}`}>
                                                {
                                                    item.children.map((child, index) => {
                                                        return (
                                                            <LinkUrl key={child.title + child.id + index} url={child.call_to_action_url} text={child.title} classes={[style.submenuLink]} />
                                                        )
                                                    })
                                                }
                                            </div>
                                        </>
                                        : <></>
                                    }
                                </li>
                            )
                        })
                    }
                </ul>
            </Container>
        </nav>
        <div className={style.copyrightBankLogos}>
            <Container classes={[style.wrapper]}>
                {/* <div className={style.bankLogos}></div> */}
                <p>© {process.env.NEXT_PUBLIC_COMPANY_NAME}, all rights reserved {new Date().getFullYear()}</p>
                <LinkUrl reactRouter={false} url='https://cubes.rs' text={'Developed by Cubes'} classes={[style.developerOrigin]} />
            </Container>
        </div>
    </section>
  )
};

export default FooterBottom;
